import { render, staticRenderFns } from "./Choose.vue?vue&type=template&id=a3d89f24"
import script from "./Choose.vue?vue&type=script&lang=js"
export * from "./Choose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3d89f24')) {
      api.createRecord('a3d89f24', component.options)
    } else {
      api.reload('a3d89f24', component.options)
    }
    module.hot.accept("./Choose.vue?vue&type=template&id=a3d89f24", function () {
      api.rerender('a3d89f24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/auth/views/Choose.vue"
export default component.exports